


























import Vue from 'vue'
import fb from '@/firebase'
import env from '@/env'
import { KENV } from '@/types/admin'
import { UserProfile } from '@/types/users'
export default Vue.extend({
  name: 'Debug',
  data: () => ({
    env: env,
    profileData: {} as UserProfile,
    cleanupResult: {},
    refreshToken: fb.functions.httpsCallable('refreshToken'),
    token: ''
  }),
  computed: {
    currentUserId (): string {
      return this.$store.direct.state.user.id
    }
  },
  methods: {
    async refreshUserToken () {
      try {
        const { data } = await this.refreshToken()
        this.token = data.token
      } catch (error) {
        console.error(error)
      }
    }
  },
  created () {
    if (this.env.environment !== KENV.Dev) {
      this.$router.push({ name: 'events' })
    }
  }
})
